"use client";

import { Header } from "@/components/refine-ui/layout/header";
import { ThemeProvider } from "@/components/refine-ui/theme/theme-provider";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { useEffect, type PropsWithChildren } from "react";
import { Sidebar } from "./sidebar";
import { useLoadingOverlay } from "@/contexts/loading-context";
import { LoadingOverlay } from "@/components/refine-ui/layout/loading-overlay";

export function Layout({ children }: PropsWithChildren) {
  const { isLoading } = useLoadingOverlay();

  return (
    <ThemeProvider>
      <SidebarProvider defaultOpen={false}>
        <Sidebar />
        <SidebarInset>
          <Header />
          <div className="flex flex-1 flex-col">
            <main
              className={cn(
                "@container/main",
                "relative",
                "h-full",
                "flex",
                "flex-col",
                "flex-1",
                "group-has-data-collapsible/sidebar-wrapper:ml-[calc(var(--sidebar-width))]",
                "group-has-data-[collapsible=icon]/sidebar-wrapper:ml-[calc(var(--sidebar-width-icon))]",
                "p-2",
              )}
            >
              <LoadingOverlay loading={isLoading}>{children}</LoadingOverlay>
            </main>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </ThemeProvider>
  );
}

Layout.displayName = "Layout";
